import React from 'react'
import { ObjectInspector } from 'react-inspector'

import { isProduction } from '@/lib/helpers/envHelpers'
import { cn } from '@/lib/utils'

type Props = Omit<React.HTMLAttributes<HTMLDivElement>, 'children'> & {
  label?: string
  data: unknown
  objectInspectorProps?: Omit<
    React.ComponentProps<typeof ObjectInspector>,
    'data'
  >
}

const Dump: React.FC<Props> = ({
  label,
  data,
  className,
  objectInspectorProps,
  ...props
}) => {
  if (isProduction()) {
    return null
  }

  return (
    <div className={cn('box-shadow-lg my-2 border p-2', className)} {...props}>
      <div className="mb-1">{label}</div>
      <ObjectInspector data={data} {...objectInspectorProps} />
    </div>
  )
}

export default Dump
